<script lang="ts">
</script>

<article class="recruit-area">
  <section class="section-title" id="career">
    <h2>採用情報</h2>
  </section>

  <section class="recruit-content content-inner">
    <img src="./img/bg-recruit.svg" alt="" />
    <div>
      <p>
        スパトレでは新しい仲間を募集しています。自ら考えて働き、自身の意見・アイディアを反映できる環境で、仕事の幅を広げて行くことが可能です。
      </p>
      <ul class="recruit-list">
        <li>ソフトウェアエンジニア</li>
        <li>コンテンツ企画・編集</li>
        <li>営業</li>
        <li>日本人サポート</li>
      </ul>
      <p>
        採用へのエントリーにつきましては、お問い合わせよりご連絡ください。
        <br />
        追って担当者より連絡いたします。
      </p>
    </div>
  </section>
</article>
